import React, { useEffect } from 'react'
import StepWizard from 'react-step-wizard'
import EpisodeOne from './step3/episode'
import EpisodeTwo from './step3/episodetwo'
import EpisodeThree from './step3/episodethree'
import EpisodeMasak from './step3/episodeMasak';
import EpisodeFour from './step3/episodeFour'
import EpisodeFive from "./step3/episodeFive";
import EpisodeSix from './step3/episodeSix';
import StepIdentity from './stepIdentity';
import EpisodeJobs from './step3/episodeJobs'
import useAppContext from '../../../../context/useAppContext';
import useGtmEvent from '../../../../hooks/useGtmEvent';
import { StepContextProvider } from '../../../../components/StepContext';

const Step3 = (props)=>{
  const { innerTexts } = useAppContext();
  const investorStep = innerTexts.noYerindelikUygunlukStep ? 2 : 3;
  const { sendGTMEvent } = useGtmEvent();

  useEffect(() => {
    if (props.currentStep === investorStep) {
      sendGTMEvent({ step: 2 });
    }
  }, [props.currentStep, investorStep, sendGTMEvent]);

    return (
      <div className="panel-body">
        <div className="container">
          <StepWizard>
            <EpisodeOne handleWizard={props} />
            <EpisodeTwo handleWizard={props} />
            <EpisodeThree handleWizard={props} />
            <EpisodeMasak currentStep={props.currentStep} handleWizard={props} />
            <EpisodeFour handleWizard={props} />
            <EpisodeFive handleWizard={props} />
            <EpisodeSix handleWizard={props} />
          </StepWizard>
        </div>
      </div>
    );

}
export default StepContextProvider(Step3)
